<template>
    <v-app-bar class="white" app flat>
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer" /> -->
      <v-icon x-large>mdi-camera</v-icon>
      <v-toolbar-title class="pl-2 display-1">TOMWEDGE</v-toolbar-title>
      <v-toolbar-title class="grey--text display-1">IMAGES</v-toolbar-title>
      <v-spacer />
      <v-btn
        v-for="footerlink in footerlinks"
        :key="footerlink.link"
        :href="footerlink.link"
        :color="footerlink.colour"
        class="mx-4"
        icon
        target="_blank"
      >
        <v-icon x-large>{{ footerlink.icon }}</v-icon>
      </v-btn>

      <template v-slot:extension>
        <v-tabs centered>
          <v-tab
            v-for="link in links"
            :key="link.text"
            :to="{
              name: link.route,
              params: { pagename: link.title, filter: link.filter },
            }"
          >{{ link.title }}</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
</template>

<script>
    export default {
        props: {
            links: {},
            footerlinks: {}
        }
        
    }
</script>

<style lang="scss" scoped>

</style>